export default "__VITE_ASSET__Dml3xhcV__"